var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en
var guid = require('aem-libs/src/guid')

angular.module('OwInputTextCmp', [])
  .component('owInputText', {
    template: require('./ow-input-text.component.tpl.html'),
    controller: OwInputTextCtrl,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      value: '<',
      onChanged: '&',
      tooltipLabel: '<',
      tooltipClass: '<'
    }
  })

OwInputTextCtrl.$inject = ['i18n']

function OwInputTextCtrl (i18n) {
  var vm = this

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)

    vm.onChange = onChange
    vm.type = (vm.formField.hidden) ? 'hidden' : 'text'
    vm.minLength = (vm.formField.validation && vm.formField.validation.minLength) ? vm.formField.validation.minLength : null
    vm.maxLength = (vm.formField.validation && vm.formField.validation.maxLength) ? vm.formField.validation.maxLength : null
    vm.pattern = (vm.formField.validation && vm.formField.validation.regexp) ? vm.formField.validation.regexp : null
    vm.id = 'field_' + vm.formField.id + '-' + guid()

    if (vm.formField.defaultValueI18N) {
      vm.value = vm.formField.defaultValueI18N
    }
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.value) {
      vm.value = changesObj.value.currentValue
    }
  }

  function onChange () {
    vm.onChanged({ value: vm.value, formFieldId: vm.formField.id })
  }
}
